import "core-js/modules/es.array.reverse.js";
var _class, _CswStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { flatten } from "lodash-es";
import { action, computed, makeObservable, runInAction } from "mobx";
import URI from "urijs";
import TerriaError, { networkRequestError } from "../../../Core/TerriaError";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadWithXhr from "../../../Core/loadWithXhr";
import loadXML from "../../../Core/loadXML";
import runLater from "../../../Core/runLater";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import xml2json from "../../../ThirdParty/xml2json";
import CswCatalogGroupTraits from "../../../Traits/TraitsClasses/CswCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import CatalogGroup from "../CatalogGroup";
import CsvCatalogItem from "../CatalogItems/CsvCatalogItem";
import GeoJsonCatalogItem from "../CatalogItems/GeoJsonCatalogItem";
import KmlCatalogItem from "../CatalogItems/KmlCatalogItem";
import ArcGisMapServerCatalogItem from "../Esri/ArcGisMapServerCatalogItem";
import defaultGetRecordsTemplate from "../Ows/CswGetRecordsTemplate.xml";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebMapServiceCatalogItem from "./WebMapServiceCatalogItem";

// WPS is disabled until wps-group support
// import wpsGetRecordsTemplate from "./CswGetRecordsWPSTemplate.xml";

function toArray(val) {
  if (!isDefined(val)) return undefined;
  return Array.isArray(val) ? val : [val];
}

// CSW Record types source files:
// http://schemas.opengis.net/csw/2.0.2/CSW-discovery.xsd
// http://schemas.opengis.net/csw/2.0.2/CSW-publication.xsd
// http://schemas.opengis.net/csw/2.0.2/csw.xsd
// http://schemas.opengis.net/csw/2.0.2/record.xsd

// Records have three types: Brief, Summary and Full
// We don't really deal with these, we just assume we have Brief and Partial<Full>

/** GetDomain request is used to get actual values for some property. In general this is a
 * subset of the value domain (that is, set of permissible values),
 * although in some cases these may be the same.
 * */

/**
 * GetRecords request is used to get a subset of records
 */

/**
 * MetadataGroups are used to represent groups generated from GetDomain request. Most important bits are `groupName`, `children`, and `records` - which are used to create catalog structure tree.
 */
let CswStratum = (_class = (_CswStratum = class CswStratum extends LoadableStratum(CswCatalogGroupTraits) {
  static async load(catalogGroup) {
    if (catalogGroup.url === undefined) {
      throw new TerriaError({
        title: i18next.t("models.csw.missingUrlTitle"),
        message: i18next.t("models.csw.missingUrlMessage")
      });
    }
    const metadataGroups = [];

    /**
     * If domainSpecification properties are set (and we aren't flattening the catalog) - we will try to create MetadataGroups * from a GetDomain response (using the specified domainPropertyName).
     *
     * An example GetDomain response (see wwwroot\test\csw\Example1GetDomain.xml):
     * ...
     * <csw:Value>Multiple Use | Fisheries Effort</csw:Value>
     * <csw:Value>Multiple Use | Pollution</csw:Value>
     * <csw:Value>Multiple Use | Sea Surface Temperature</csw:Value>
     * <csw:Value>Multiple Use | Seismic Surveys</csw:Value>
     * <csw:Value>Multiple Use | Shipping</csw:Value>
     * ...
     *
     * These strings are used to generate MetadataGroups with:
     * - Hierarchy separator used to split strings into pieces (domainSpecification.hierarchySeparator = " | ")
     * - Query property name used to match values to Records (domainSpecification.queryPropertyName = "subject"). That is to say, we will search through Record["subject"] to add Records to sepcific MetadataGroups
     */
    if (!catalogGroup.flatten && catalogGroup.domainSpecification.domainPropertyName && catalogGroup.domainSpecification.hierarchySeparator && catalogGroup.domainSpecification.queryPropertyName) {
      var _toArray;
      const getDomainUrl = new URI(proxyCatalogItemUrl(catalogGroup, catalogGroup.url)).query({
        service: "CSW",
        version: "2.0.2",
        request: "GetDomain",
        propertyname: catalogGroup.domainSpecification.domainPropertyName
      });
      let domainResponse;
      try {
        const xml = await loadXML(getDomainUrl.toString());
        if (!xml || !xml.documentElement || xml.documentElement.localName !== "GetDomainResponse") {
          throw "Invalid XML response";
        }
        domainResponse = xml2json(xml);
      } catch (error) {
        console.log(error);
        throw networkRequestError({
          sender: catalogGroup,
          title: i18next.t("models.csw.notUseableTitle"),
          message: i18next.t("models.csw.notUseableMessage")
        });
      }
      if (!domainResponse) {
        throw networkRequestError({
          sender: catalogGroup,
          title: i18next.t("models.csw.errorLoadingTitle"),
          message: i18next.t("models.csw.checkCORSDomain")
        });
      }

      // Get flat listOfValues
      const listOfValues = flatten((_toArray = toArray(domainResponse.DomainValues)) === null || _toArray === void 0 ? void 0 : _toArray.map(d => {
        var _d$ListOfValues;
        return toArray(d === null || d === void 0 || (_d$ListOfValues = d.ListOfValues) === null || _d$ListOfValues === void 0 ? void 0 : _d$ListOfValues.Value);
      })).filter(v => typeof v === "string");

      // Create metadataGroups from listOfValues
      listOfValues.forEach(value => {
        const keys = value.split(catalogGroup.domainSpecification.hierarchySeparator);
        // recursively find the group that the last key in keys should belong to and add that key
        addMetadataGroups(keys, 0, metadataGroups, catalogGroup.domainSpecification.hierarchySeparator, catalogGroup.domainSpecification.queryPropertyName);
      });
    }

    // Get Records
    let paging = true;
    let startPosition = 1;
    const records = [];

    // We have to paginate through Records
    while (paging) {
      var _catalogGroup$getReco, _json$SearchResults$R, _json$SearchResults, _json$SearchResults2, _json$SearchResults$n, _json$SearchResults3, _json$SearchResults4, _json$SearchResults5, _json$SearchResults$n2, _json$SearchResults6, _json$SearchResults7;
      // Replace {startPosition}
      const postData = ((_catalogGroup$getReco = catalogGroup.getRecordsTemplate) !== null && _catalogGroup$getReco !== void 0 ? _catalogGroup$getReco : defaultGetRecordsTemplate).replace("{startPosition}", startPosition);
      const xml = await loadWithXhr({
        url: proxyCatalogItemUrl(catalogGroup, new URI(catalogGroup.url).query("").toString(), "1d"),
        responseType: "document",
        method: "POST",
        overrideMimeType: "text/xml",
        data: postData,
        headers: {
          "Content-Type": "application/xml"
        }
      });
      if (!isDefined(xml)) {
        throw networkRequestError({
          sender: catalogGroup,
          title: i18next.t("models.csw.errorLoadingRecordsTitle"),
          message: i18next.t("models.csw.errorLoadingRecordsMessage")
        });
      }
      const json = xml2json(xml);
      if (json.Exception) {
        let errorMessage = i18next.t("models.csw.unknownError");
        if (json.Exception.ExceptionText) {
          errorMessage = i18next.t("models.csw.exceptionMessage", {
            exceptionText: json.Exception.ExceptionText
          });
        }
        throw new TerriaError({
          sender: catalogGroup,
          title: i18next.t("models.csw.errorLoadingTitle"),
          message: errorMessage
        });
      }
      records.push(...((_json$SearchResults$R = json === null || json === void 0 || (_json$SearchResults = json.SearchResults) === null || _json$SearchResults === void 0 ? void 0 : _json$SearchResults.Record) !== null && _json$SearchResults$R !== void 0 ? _json$SearchResults$R : []));

      // Get next start position - or stop pageing
      const nextRecord = typeof (json === null || json === void 0 || (_json$SearchResults2 = json.SearchResults) === null || _json$SearchResults2 === void 0 ? void 0 : _json$SearchResults2.nextRecord) === "string" ? parseInt((_json$SearchResults$n = json === null || json === void 0 || (_json$SearchResults3 = json.SearchResults) === null || _json$SearchResults3 === void 0 ? void 0 : _json$SearchResults3.nextRecord) !== null && _json$SearchResults$n !== void 0 ? _json$SearchResults$n : "0", 10) : json === null || json === void 0 || (_json$SearchResults4 = json.SearchResults) === null || _json$SearchResults4 === void 0 ? void 0 : _json$SearchResults4.nextRecord;
      const numberOfRecordsMatched = typeof (json === null || json === void 0 || (_json$SearchResults5 = json.SearchResults) === null || _json$SearchResults5 === void 0 ? void 0 : _json$SearchResults5.numberOfRecordsMatched) === "string" ? parseInt((_json$SearchResults$n2 = json === null || json === void 0 || (_json$SearchResults6 = json.SearchResults) === null || _json$SearchResults6 === void 0 ? void 0 : _json$SearchResults6.numberOfRecordsMatched) !== null && _json$SearchResults$n2 !== void 0 ? _json$SearchResults$n2 : "0", 10) : json === null || json === void 0 || (_json$SearchResults7 = json.SearchResults) === null || _json$SearchResults7 === void 0 ? void 0 : _json$SearchResults7.numberOfRecordsMatched;
      if (!isDefined(nextRecord) || nextRecord === 0 || nextRecord >= numberOfRecordsMatched) {
        paging = false;
      } else {
        startPosition = nextRecord;
      }
    }

    // If we have metadataGroups, add records to them
    if (metadataGroups.length > 0) {
      records.forEach(record => {
        var _findGroup;
        (_findGroup = findGroup(metadataGroups, record)) === null || _findGroup === void 0 || _findGroup.records.push(record);
      });
    }
    return new CswStratum(catalogGroup, metadataGroups, records);
  }
  constructor(catalogGroup, metadataGroups, records) {
    super();
    this.catalogGroup = catalogGroup;
    this.metadataGroups = metadataGroups;
    this.records = records;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new CswStratum(model, this.metadataGroups, this.records);
  }
  get members() {
    // If no metadataGroups - return flat list of record ids
    if (this.metadataGroups.length === 0) {
      return this.records.map(r => "".concat(this.catalogGroup.uniqueId, "/").concat(r.identifier));
    }
    return this.metadataGroups.map(g => "".concat(this.catalogGroup.uniqueId, "/").concat(g.groupName));
  }
  createMembersFromLayers() {
    // If no metadata groups -> just create all records
    if (this.metadataGroups.length === 0) {
      this.records.forEach(record => this.createRecord(this.catalogGroup.uniqueId, record));

      // If metadata groups -> create them (records will then be created for each group)
    } else {
      this.metadataGroups.forEach(metadataGroup => this.createMetadataGroup(this.catalogGroup.uniqueId, metadataGroup));
    }
  }
  createMetadataGroup(parentId, metadataGroup) {
    const layerId = "".concat(parentId, "/").concat(metadataGroup.groupName);
    const existingModel = this.catalogGroup.terria.getModelById(CatalogGroup, layerId);
    let model;
    if (existingModel === undefined) {
      model = new CatalogGroup(layerId, this.catalogGroup.terria);
      this.catalogGroup.terria.addModel(model);
    } else {
      model = existingModel;
    }
    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", metadataGroup.groupName);
    model.setTrait(CommonStrata.definition, "members", filterOutUndefined([...metadataGroup.children.map(childMetadataGroup => this.createMetadataGroup(layerId, childMetadataGroup).uniqueId), ...metadataGroup.records.map(record => {
      var _this$createRecord;
      return (_this$createRecord = this.createRecord(layerId, record)) === null || _this$createRecord === void 0 ? void 0 : _this$createRecord.uniqueId;
    })]));
    return model;
  }
  createRecord(parentId, record) {
    var _record$URI;
    const uris = toArray((_record$URI = record.URI) !== null && _record$URI !== void 0 ? _record$URI : record.references);
    if (!isDefined(uris)) {
      return;
    }
    /**
     * Array of acceptable URLS for catalog item. Its indices map to resourceFormats' index.
     * For example - if `acceptableUrls[1]` is defined, it maps to `resourceFormats[1]` - which is a ArcGisMapServerCatalogItem
     */
    const acceptableUris = [];

    /**
     * There may be more than one url that results in a data layer here - so check for
     * the acceptable ones, store the others as downloadUrls that can be
     * displayed in the metadata summary for the layer
     */
    const downloadUrls = [];
    let legendUri = undefined;
    const filteredResourceFormats = this.resourceFormats.filter(f => f.enabled);
    for (let m = 0; m < uris.length; m++) {
      const uri = uris[m];
      if (!uri) return;
      const resourceIndex = filteredResourceFormats.findIndex(f => {
        var _ref, _protocol;
        return (_ref = (_protocol = uri.protocol) !== null && _protocol !== void 0 ? _protocol : uri.scheme) === null || _ref === void 0 ? void 0 : _ref.match(f.regex);
      });

      // If matching resource is found, and an acceptable URL hasn't been set for it -> add it
      if (resourceIndex !== -1 && !acceptableUris[resourceIndex]) {
        acceptableUris[resourceIndex] = uri;
      } else {
        if ((uri === null || uri === void 0 ? void 0 : uri.description) === "LegendUrl") {
          legendUri = uri;
        }
        downloadUrls.push({
          url: uri.toString(),
          description: uri.description ? uri.description : uri.name
        });
      }
    }
    const layerId = "".concat(parentId, "/").concat(record.identifier);
    const urlIndex = acceptableUris.findIndex(url => isDefined(url));
    if (urlIndex !== -1) {
      var _record$title;
      const modelConstructor = this.resourceFormats[urlIndex].contructor;
      const existingModel = this.catalogGroup.terria.getModelById(modelConstructor, layerId);
      let model;
      if (existingModel === undefined) {
        model = new modelConstructor(layerId, this.catalogGroup.terria);
        this.catalogGroup.terria.addModel(model);
      } else {
        model = existingModel;
      }
      // Replace the stratum inherited from the parent group.
      model.strata.delete(CommonStrata.definition);
      model.setTrait(CommonStrata.definition, "name", (_record$title = record.title) !== null && _record$title !== void 0 ? _record$title : record.identifier);
      const uri = acceptableUris[urlIndex];
      model.setTrait(CommonStrata.definition, "url", uri.toString());
      if (record.abstract) {
        var _toArray2;
        model.setTrait(CommonStrata.definition, "description", (_toArray2 = toArray(record.abstract)) === null || _toArray2 === void 0 ? void 0 : _toArray2.join("\n\n"));
      } else if (record.description) {
        var _toArray3;
        model.setTrait(CommonStrata.definition, "description", (_toArray3 = toArray(record.description)) === null || _toArray3 === void 0 ? void 0 : _toArray3.join("\n\n"));
      }
      const infoSections = [];
      if (record.contributor && toArray(record.contributor).length > 0) {
        var _toArray4;
        infoSections.push({
          name: i18next.t("models.csw.dataResponsibility"),
          content: (_toArray4 = toArray(record.contributor)) === null || _toArray4 === void 0 ? void 0 : _toArray4.join("\n\n")
        });
      }
      infoSections.push({
        name: i18next.t("models.csw.links"),
        content: downloadUrls.map(d => "[".concat(d.description, "](").concat(d.url, ")")).join("\n\n")
      });
      model.setTrait(CommonStrata.definition, "info", infoSections);
      model.setTrait(CommonStrata.definition, "metadataUrls", [{
        title: i18next.t("models.csw.metadataURL"),
        url: new URI(proxyCatalogItemUrl(this.catalogGroup, this.catalogGroup.url)).query({
          service: "CSW",
          version: "2.0.2",
          request: "GetRecordById",
          outputSchema: "http://www.opengis.net/cat/csw/2.0.2",
          ElementSetName: "full",
          id: record.identifier
        }).toString()
      }]);
      if (legendUri) {
        model.setTrait(CommonStrata.definition, "legends", [{
          url: legendUri.toString()
        }]);
      }

      // If this is a WMS item, we MUST set `layers` trait to `uri.name`
      if (model instanceof WebMapServiceCatalogItem) {
        if (!uri.name) {
          return;
        }
        model.setTrait(CommonStrata.definition, "layers", uri.name);
      }

      // Same with ArcGis MapServer
      if (model instanceof ArcGisMapServerCatalogItem) {
        if (!uri.name) {
          return;
        }
        model.setTrait(CommonStrata.definition, "layers", uri.name);
      }
      return model;
    }
  }

  /**
   * These are used to match URLs to model constructors
   */
  get resourceFormats() {
    return [{
      enabled: this.catalogGroup.includeWms,
      regex: new RegExp(this.catalogGroup.wmsResourceFormat, "i"),
      contructor: WebMapServiceCatalogItem
    }, {
      enabled: this.catalogGroup.includeEsriMapServer,
      regex: new RegExp(this.catalogGroup.esriMapServerResourceFormat, "i"),
      contructor: ArcGisMapServerCatalogItem
    }, {
      enabled: this.catalogGroup.includeKml,
      regex: new RegExp(this.catalogGroup.kmlResourceFormat, "i"),
      contructor: KmlCatalogItem
    }, {
      enabled: this.catalogGroup.includeGeoJson,
      regex: new RegExp(this.catalogGroup.geoJsonResourceFormat, "i"),
      contructor: GeoJsonCatalogItem
    }, {
      enabled: this.catalogGroup.includeCsv,
      regex: new RegExp(this.catalogGroup.csvResourceFormat, "i"),
      contructor: CsvCatalogItem
    }];
  }
}, _defineProperty(_CswStratum, "stratumName", "CswStratum"), _CswStratum), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembersFromLayers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembersFromLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMetadataGroup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMetadataGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createRecord", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createRecord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resourceFormats", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resourceFormats"), _class.prototype), _class);
/**
 * Recursively add MetadataGroups from keys (which are split DomainValue)
 */
function addMetadataGroups(keys, index, group, separator, queryField) {
  if (index > keys.length - 1) return;
  let groupIndex = group.findIndex(g => g.groupName === keys[index]);
  if (groupIndex === -1) {
    // not found so add it
    let value;
    let regex = true;
    // if we aren't at the last key, use a regex and tack on another separator to avoid mismatches
    if (index + 1 !== keys.length) {
      const sepRegex = separator.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      value = "^" + keys.slice(0, index + 1).join(sepRegex) + sepRegex;
    } else {
      value = keys.slice(0, index + 1).join(separator);
      regex = false;
    }
    group.push({
      field: queryField,
      value: value,
      regex: regex,
      groupName: keys[index],
      children: [],
      records: []
    });
    groupIndex = group.length - 1;
  }
  addMetadataGroups(keys, index + 1, group[groupIndex].children, separator, queryField);
}

// find groups that the record belongs to
function findGroup(metadataGroups, record) {
  for (let i = 0; i < metadataGroups.length; i++) {
    const group = metadataGroups[i];
    if (group.field) {
      var _toArray5;
      const fields = filterOutUndefined((_toArray5 = toArray(record[group.field])) !== null && _toArray5 !== void 0 ? _toArray5 : []);
      if (fields.find(f => matchValue(group.value, f, group.regex))) {
        if (group.children) {
          // recurse to see if it fits into any of the children
          const childGroup = findGroup(group.children, record);
          if (isDefined(childGroup)) {
            return childGroup;
          }
        }
        return group;
      }
    }
  }
}
function matchValue(value, recordValue, regex) {
  if (isDefined(regex) && regex) {
    // regular expression so parse it and check string against it
    const regExp = new RegExp(value);
    return regExp.test(recordValue);
  } else {
    return value === recordValue;
  }
}
StratumOrder.addLoadStratum(CswStratum.stratumName);
export default class CswCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(CswCatalogGroupTraits)))) {
  get type() {
    return CswCatalogGroup.type;
  }
  async forceLoadMetadata() {
    if (this.strata.get(CswStratum.stratumName) !== undefined) return;
    const stratum = await CswStratum.load(this);
    runInAction(() => {
      this.strata.set(CswStratum.stratumName, stratum);
    });
  }
  async forceLoadMembers() {
    const cswStratum = this.strata.get(CswStratum.stratumName);
    if (cswStratum) {
      await runLater(() => cswStratum.createMembersFromLayers());
    }
  }
}
_defineProperty(CswCatalogGroup, "type", "csw-group");